export const PhoneLocationOptions = [
  { id: 'Office', name: 'Office' },
  { id: 'Home', name: 'Home' },
  { id: 'Mobile', name: 'Mobile' },
];

export const PhoneTypeOptions = [
  { id: 'Direct Line', name: 'Direct Line' },
  { id: 'Fax', name: 'Fax' },
];